import { isChangeAppHostname } from './isChangeAppHostname';

/**
 * Parses `url` against `baseUrl`. Returns `null` (never throws) when either is unparseable, when
 * `baseUrl` is not a Change app host, or when `url` carries credentials.
 */
export function parseChangeUrl(url: string, baseUrl: string): { parsedUrl: URL; parsedBaseUrl: URL } | null {
	try {
		const parsedBaseUrl = new URL(baseUrl);
		if (!isChangeAppHostname(parsedBaseUrl.hostname)) {
			return null;
		}
		const parsedUrl = new URL(url, parsedBaseUrl);
		if (parsedUrl.username || parsedUrl.password) {
			return null;
		}
		return { parsedUrl, parsedBaseUrl };
	} catch {
		return null;
	}
}

/** `https:` always, `http:` only when `baseUrl` is itself `http:` (local dev). */
export function isAllowedProtocol(parsedUrl: URL, parsedBaseUrl: URL): boolean {
	return parsedUrl.protocol === 'https:' || (parsedUrl.protocol === 'http:' && parsedBaseUrl.protocol === 'http:');
}
